import {
	useState,
	useEffect,
	ChangeEvent
} from 'react';
import styles from '../FilterOptions.module.scss';
import { AddressPicker, Spacer } from '@components/index';
import { SPACER_DIRECTION, TypeAheadOption } from '@types';
import SearchIcon from '@mui/icons-material/Search';

type FilterProps = {
    meta: any;
    header: any;
    filterData: any;
    onChange: (val:any) => void;
}

export const FilterRegion = (props:FilterProps) => {
	const {
		meta,
		filterData,
		onChange,
	} = props;
	const [newFields, setNewFields] = useState(0);
	const [inputVals, setInputVals] = useState<any[]>([]);

	const changeFieldCount = (add:boolean, key:number = 0) => {
		const newFilterData = { ...filterData };
		if (add) {
			setNewFields(newFields + 1);
			newFilterData.repeats = newFields + 1;
			newFilterData.value = inputVals;
		} else {
			if (key > 0) {
				const cloned = [...inputVals].filter((_, index) => {
					return index !== key;
				});
				setInputVals(cloned);
				newFilterData.value = cloned;
			}
			setNewFields(newFields - 1);
			newFilterData.repeats = newFields - 1;
		}
		newFilterData.columnField = meta?.databaseLocation;
		newFilterData.operatorValue = newFields === 0 ? 'contains' : 'In'; // TODO: contains?
		onChange(newFilterData);
	}

	const updateSelectRegion = (v: ChangeEvent<HTMLInputElement> | string | TypeAheadOption, i:number, fromSearch:boolean) => {
		const cloned = [...inputVals];
		if ((v as ChangeEvent<HTMLInputElement>).target && (v as ChangeEvent<HTMLInputElement>).target.value !== '' && !fromSearch) {
			cloned[i] = (v as ChangeEvent<HTMLInputElement>).target.value;
			setInputVals(cloned);
		} else if ((v as ChangeEvent<HTMLInputElement>).target && (v as ChangeEvent<HTMLInputElement>).target.value === '') {
			cloned[i] = '';
			setInputVals(cloned);
		} else if (fromSearch) {
			cloned[i] = (v as TypeAheadOption).value;
			setInputVals(cloned);
			const newFilterData = {
				...filterData,
				value: cloned,
				repeats: newFields,
				columnField: meta?.databaseLocation,
				operatorValue: newFields === 0 ? 'contains' : 'In'
			}
			onChange(newFilterData);
		}
	}

	useEffect(() => {
		if (filterData?.value) {
			setInputVals(filterData.value || []);
			setNewFields(filterData.repeats || 0);
		} else {
			setInputVals([]);
			setNewFields(0);
		}
	}, [filterData]);
	return (
		<>
			{
				<div className={styles.inputContainer}>
					<div style={{ flex: 1 }}>
						<AddressPicker
							locationType='REGION'
							name={'Filter-Option-Region'}
							value={inputVals[0] || ''}
							onChange={(v) => updateSelectRegion(v, 0, false)}
							onSelected={(v) => updateSelectRegion(v as string, 0, true)}
							options={null}
							keepErrorSpace={false}
							Icon={SearchIcon}
						/>
					</div>
					{meta?.filterOptions?.allowAdditional && <>
						<Spacer dir={SPACER_DIRECTION.VERTICAL} size={5} />
						<button onClick={() => changeFieldCount(true)} className={styles.addMoreBtn} aria-label={'Add Region Field'}>+</button>
					</>}
				</div>
			}
			{
				newFields > 0 && new Array(newFields).fill(null).map((_, key) => {
					return <div key={key} className={styles.inputContainer} style={{ marginTop: '5px' }}>
						<div style={{ flex: 1 }}>
							<AddressPicker
								locationType='REGION'
								name={`Filter-Option-Region-${key}`}
								value={inputVals[key + 1] || ''}
								onChange={(v) => updateSelectRegion(v, key + 1, false)}
								onSelected={(v) => updateSelectRegion(v as string, key + 1, true)}
								options={null}
								keepErrorSpace={false}
								Icon={SearchIcon}
							/>
						</div>
						<>
							<Spacer dir={SPACER_DIRECTION.VERTICAL} size={5} />
							<button onClick={() => changeFieldCount(false, key + 1)} className={styles.addMoreBtn} aria-label={'Remove Region Field'}>-</button>
						</>
					</div>
				})
			}
		</>
	)
}
